import { render, staticRenderFns } from "./pbnum.vue?vue&type=template&id=a9499410&scoped=true"
import script from "./pbnum.vue?vue&type=script&lang=js"
export * from "./pbnum.vue?vue&type=script&lang=js"
import style0 from "./pbnum.vue?vue&type=style&index=0&id=a9499410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9499410",
  null
  
)

export default component.exports